/**
 * Derives loading UI flags from TanStack Query state.
 * Distinguishes initial load (blocking skeleton) from background refetch.
 * Pass isPlaceholderData=true to treat placeholder (keepPreviousData) as no-data
 * so the skeleton shows during cycle switches instead of stale content.
 */
export function useQueryShellState({
  data,
  isPending = false,
  isFetching = false,
  isPlaceholderData = false,
  requireNonEmptyArray = false,
}) {
  const hasData = requireNonEmptyArray
    ? Array.isArray(data) && data.length > 0
    : data != null;

  const hasRealData = hasData && !isPlaceholderData;
  const showBlockingSkeleton = (isPending || isPlaceholderData) && !hasRealData;
  const showRefreshHint = isFetching && hasRealData && !showBlockingSkeleton;

  return {
    hasData: hasRealData,
    showBlockingSkeleton,
    showRefreshHint,
    isFetching,
    isPending,
  };
}

/**
 * Combina vários shells para o gate de carga inicial da página.
 * Bloqueia enquanto **qualquer** query primária ainda não tem dados.
 */
export function combineQueryShellStates(...states) {
  return {
    showBlockingSkeleton: states.some((s) => s.showBlockingSkeleton),
    showRefreshHint: states.some((s) => s.showRefreshHint),
    hasData: states.every((s) => s.hasData),
  };
}
